
import { environment } from "../../../../Environments/environment";
import { PostAsyncHelper } from "../../../../redux/interfaces/types";


export const checkEmailisAvailable = async (email) => {
    try {
        const url = environment.apiUrl + 'memberemailisavailable';
        const response = await PostAsyncHelper(url, { email: email });

        if (response?.data?.status === "success") {
            return true;
        }
        return false;
    }
    catch {
        return false;


    }
}

export const checkRoomPrice = async (priceCheckUri) => {
    try {
        const baseUrl = `${environment.apiUrl}muv-meta-engine/expedia/checkRoomPrice`;
        const url = `${baseUrl}?priceCheckUri=${encodeURIComponent(priceCheckUri)}`;

        const response = await PostAsyncHelper(url);

        return response?.data?.result?.book?.href;


    } catch (error) {
        console.error("Room price check failed:", error);
        return false;
    }
};